export default {
  enterpriseCrewLaborId: state => {
    if(!state.crew.enterprise_crew_labor_select) return false;
    return state.crew.enterprise_crew_labor_select.crew_labor.id;
  },
  labor: state => {
    if(!state.crew.enterprise_crew_labor_select) return {};
    return state.crew.enterprise_crew_labor_select.crew_labor;
  },
  selectedCrewLaborId: state => {
    if(!state.crew.enterprise_crew_labor_select) return false;
    return state.crew.enterprise_crew_labor_select.crew_labor.id;
  },
  crewName: state => {
    if(!state.crew.name) return false;
    return state.crew.name;
  }
};
